"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStopDictate;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useStopDictate() {
  return (0, _useWebChatAPIContext.default)().stopDictate;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTdG9wRGljdGF0ZS50cyJdLCJuYW1lcyI6WyJ1c2VTdG9wRGljdGF0ZSIsInN0b3BEaWN0YXRlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxjQUFULEdBQXNDO0FBQ25ELFNBQU8scUNBQXVCQyxXQUE5QjtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVN0b3BEaWN0YXRlKCk6ICgpID0+IHZvaWQge1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5zdG9wRGljdGF0ZTtcbn1cbiJdfQ==